import styled from "styled-components";
import { Typography } from "antd";
import { SB_COLORS } from "theme/SbThemeV2";

// ─── Brand color (sourced from the central theme) ─

export const CIRCLE_TEAL = SB_COLORS.primary;

// ─── Circle dimensions ────────────────────────────────────────────────────────

export const CIRCLE_SIZE     = 96;
export const CIRCLE_STROKE_W = 8;

// ─── Layout ───────────────────────────────────────────────────────────────────

export const CardWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
`;

// ─── Progress circle format label ─────────────────────────────────────────────

export const CircleFormatTextStyled = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: ${CIRCLE_TEAL};
`;

// ─── Card title and subtitle ──────────────────────────────────────────────────

export const CardTitleStyled = styled(Typography.Text)`
  font-size: 13px;
  margin-top: 4px;
`;

export const CardSubtitleStyled = styled(Typography.Text)`
  font-size: 11px;
`;
